import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Nav from '../components/Nav';

export default function RootLayout() {
  const vantaRef = useRef(null);
  const vantaEffect = useRef(null);

  useEffect(() => {
    const initVanta = () => {
      if (!vantaEffect.current && window.VANTA && window.THREE && vantaRef.current) {
        try {
          vantaEffect.current = window.VANTA.FOG({
            el: vantaRef.current,
            mouseControls: true,
            touchControls: true,
            gyroControls: true,
            minHeight: 100.00,
            minWidth: 100.00,
            highlightColor: 0x1a1a1a,
            midtoneColor: 0x303030,
            lowlightColor: 0x373738,
            baseColor: 0x0,
            blurFactor: 0.66,
            speed: 2.00,
            zoom: 3.50
          });
        } catch (error) {
          console.error('Vanta initialization error:', error);
        }
      }
    };

    // Try to initialize immediately
    initVanta();

    // If not ready, try again after a short delay
    const timer = setTimeout(initVanta, 100);

    return () => {
      clearTimeout(timer);
      if (vantaEffect.current) {
        vantaEffect.current.destroy();
        vantaEffect.current = null;
      }
    };
  }, []);

  return (
    <>
      <div ref={vantaRef} className="min-h-screen overflow-hidden bg-site bg-no-repeat bg-cover">
        <div className="app-content-wrapper">
          <Header />
          <div>
            <Outlet />
          </div>
        </div>
        <Nav />
      </div>
    </>
  );
}
